module.exports = __webpack_public_path__ + "static/offers-worker-1b82b2a73124db9bd06571ed9f7820e6.svg";